import Cookies from 'js-cookie';
import { useLocale as useNextIntlLocale } from 'next-intl';
import { useEffect, useState } from 'react';
import { CookiesType } from 'types/enums';

export const useActualLocale = (): string => {
  const defaultLocale = useNextIntlLocale();
  const [actualLocale, setActualLocale] = useState(defaultLocale);

  useEffect(() => {
    const cookieLocale = Cookies.get(CookiesType.locale);
    if (cookieLocale) {
      setActualLocale(cookieLocale);
    }

    const checkCookieChange = () => {
      const currentCookieLocale = Cookies.get(CookiesType.locale);
      if (currentCookieLocale && currentCookieLocale !== actualLocale) {
        setActualLocale(currentCookieLocale);
      }
    };

    const intervalId = setInterval(checkCookieChange, 100);

    return () => clearInterval(intervalId);
  }, [actualLocale]);

  return actualLocale;
};

export default useActualLocale;
